class NumberFormat {
    public Currency = (value: number) => {
        return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
    }
}

const numberFormat = new NumberFormat();
export default numberFormat;
